import { Menu } from '@material-ui/core';
import styled from 'styled-components';

export const Container = styled.div``;

export const MaterialMenu = styled(Menu)`
  .MuiListItemIcon-root {
    display: flex;
    align-items: center;

    svg {
      margin-right: 8px;
      color: #eb0045;
    }
  }
`;
